import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {RewardService} from "../../../../../shared/services/reward.service";
import {RewardsSummaryService} from "../../../../../shared/services/rewards-summary.service";
import {environment} from '../../../../../../environments/environment';
import {LogService} from "../../../../../shared/services/LogService";

@Component({
    selector: 'app-promotion-code',
    templateUrl: './promotion-code.component.html',
    styleUrls: ['./promotion-code.component.scss']
})
export class PromotionCodeComponent implements OnInit {
    @Input() partnerDetails: any;
    partnerDetailContentURL: any;
    showLoading = true;
    @Input() isWebView;
    displayPromoCode: any = null;
    displayParnterPromoURL: any = null;
    isPromoCodeURL: boolean = false;
    apiErrorMessage: any;
    isErorrInAPI = false;
    partnerOfferAvailable = true;
    currentEnvironment: any;
    channel: any;
    @Output() partnerRedeemObject: EventEmitter<any> = new EventEmitter();

    constructor(private rewardService: RewardService, private rewardSummaryService: RewardsSummaryService,
                private logService: LogService) {
    }

    ngOnInit(): void {
        if (this.partnerDetails) {
            if (this.partnerDetails.isStatic) {
                this.isPromoCodeURL = this.isValidHttpUrl(this.partnerDetails.staticPromo);
                if (this.isPromoCodeURL) {
                    //display static promo
                    this.isPromoCodeURL = true;
                    this.displayParnterPromoURL = this.partnerDetails.staticPromo;
                    if (this.isWebView) {
                        this.logService.log('Web View : Static promocode url'+ ' : ' + JSON.stringify(this.displayParnterPromoURL), this.partnerDetails.currentEnvironment, this.partnerDetails.banner);
                    }
                    this.showLoading = false;
                } else {
                    this.displayPromoCode = this.partnerDetails.staticPromo;
                    this.displayParnterPromoURL = this.partnerDetails.partnerExternalUrl;
                    if (this.isWebView) {
                        this.logService.log('Web View : Static promocode'+ ' : ' + JSON.stringify(this.displayPromoCode), this.partnerDetails.currentEnvironment, this.partnerDetails.banner);
                    }
                    this.showLoading = false;
                }
            } else {
                // call dynamic promo API
                this.callDynamicPromoAPI();
            }
        }
    }

    callDynamicPromoAPI() {
        let promotionCodeLinkUrl: any;
        if (this.isWebView) {
            this.currentEnvironment = this.partnerDetails.currentEnvironment;
            promotionCodeLinkUrl = this.rewardService.getMobileApplicationDomainURL(this.currentEnvironment, this.partnerDetails.banner) + environment[this.currentEnvironment].rewardsLookupConfig.loyaltyPromotionsCodeLink;
            promotionCodeLinkUrl = promotionCodeLinkUrl + '?partnerOfferId=' + this.partnerDetails.partnerOfferId;
            this.channel= 'app-' +this.partnerDetails.channelInfo;
        } else {
            this.currentEnvironment = this.rewardSummaryService.getEnvironment();
            promotionCodeLinkUrl = this.rewardService.getApplicationDomainURL() + environment[this.currentEnvironment].rewardsLookupConfig.loyaltyPromotionsCodeLink;
            promotionCodeLinkUrl = promotionCodeLinkUrl + '?partnerOfferId=' + this.partnerDetails.partnerOfferId;
            this.channel= 'web';
        }
        this.rewardService.getDynamicPartnerPromoCodeLink(promotionCodeLinkUrl, this.currentEnvironment, this.partnerDetails.partnerOfferId, this.partnerDetails.userInfo, this.channel).subscribe((promoCodeLinkResponse: any) => {
            if (promoCodeLinkResponse) {
                if(this.isWebView) {
                    this.logService.log('Web View : API Response'+ ' : ' + JSON.stringify(promoCodeLinkResponse), this.partnerDetails.currentEnvironment, this.partnerDetails.banner);
                }
                this.showLoading = false;
                if (promoCodeLinkResponse.errors) {
                    this.partnerOfferAvailable = false;
                } else {
                    if (promoCodeLinkResponse.promoCode) {
                        this.isPromoCodeURL = false;
                        this.displayPromoCode = promoCodeLinkResponse.promoCode
                        this.displayParnterPromoURL = this.partnerDetails.partnerExternalUrl
                        this.partnerOfferAvailable = true;
                    } else if (promoCodeLinkResponse.promoUrl) {
                        this.isPromoCodeURL = true;
                        this.displayParnterPromoURL = promoCodeLinkResponse.promoUrl
                        this.partnerOfferAvailable = true;
                    } else {
                        this.partnerOfferAvailable = false;
                    }
                }

            } else {
                this.partnerOfferAvailable = false;
                this.showLoading = false;
            }
        }, error => {
            if(this.isWebView) {
                this.logService.log('Web View : ERROR'+ ' : ' + JSON.stringify(error), this.partnerDetails.currentEnvironment, this.partnerDetails.banner);
            }
            this.handleErrorForPromoAPI(error);
        })
    }

    copyCodeRedeem() {
        if (this.isWebView) {
            var returnCopyCodeRedeemObject = {
                respCode: 1,
                isCode: !this.isPromoCodeURL,
                displayPromoCode: this.displayPromoCode,
                partnerExternalUrl: this.displayParnterPromoURL

            }
            this.partnerRedeemObject.emit(returnCopyCodeRedeemObject);
        } else {
            if (this.displayPromoCode && navigator.clipboard) {
                navigator.clipboard.writeText(this.displayPromoCode);
            }
            window.open(this.displayParnterPromoURL, '_blank').focus();
        }
    }

    openURL() {
        if (this.isWebView) {
            var returnPromoURLObject = {
                respCode: 2,
                isCode: !this.isPromoCodeURL,
                partnerExternalUrl: this.displayParnterPromoURL,

            }
            this.partnerRedeemObject.emit(returnPromoURLObject);
        } else {
            window.open(this.displayParnterPromoURL, '_blank').focus();
        }
    }

    handleErrorForPromoAPI(error) {
        this.showLoading = false;
        this.isErorrInAPI = true;
        if (error[0]) {
            if (error[0].message) {
                this.apiErrorMessage = "We’re sorry, this page failed to load. Please refresh this page or contact customer service.";
            } else {
                this.apiErrorMessage = "We’re sorry, this page failed to load. Please refresh this page or contact customer service.";
            }
        } else {
            this.apiErrorMessage = "We’re sorry, this page failed to load. Please refresh this page or contact customer service.";
        }
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setError('no-value', 'partner-offers|error', this.apiErrorMessage);
        }
    }

    isValidHttpUrl(strValue) {
        let url;
        try {
            url = new URL(strValue);
        } catch (_) {
            return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
    }

    openDealsPage() {
        if (this.isWebView) {
            var returnCopyCodeRedeemObject = {
                respCode: 3,
            }
            this.partnerRedeemObject.emit(returnCopyCodeRedeemObject);
        } else {
            window.location.href = '/foru/coupons-deals.html'
        }
    }


}
